import { FraudRiskLevel } from "./fraudRisk";

export enum AuthenticityTone {
  SUCCESS = "SUCCESS",
  WARNING = "WARNING",
  ERROR = "ERROR"
}

const RISK_LEVEL_TONE: Record<FraudRiskLevel, AuthenticityTone> = {
  [FraudRiskLevel.Low]: AuthenticityTone.SUCCESS,
  [FraudRiskLevel.Medium]: AuthenticityTone.WARNING,
  [FraudRiskLevel.High]: AuthenticityTone.ERROR
};

export const resolveAuthenticityTone = (
  riskLevel: FraudRiskLevel | null,
  score: number | null
): AuthenticityTone => {
  if (riskLevel) return RISK_LEVEL_TONE[riskLevel];

  if (typeof score !== "number") return AuthenticityTone.SUCCESS;
  if (score <= 65) return AuthenticityTone.ERROR;
  if (score <= 70) return AuthenticityTone.WARNING;

  return AuthenticityTone.SUCCESS;
};
